import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { WelcomeScene } from "@/components/home/WelcomeScene";
import { Gallery } from "@/components/home/Gallery";
import { HeroVsVillain } from "@/components/home/HeroVsVillain";
import { CartoonSection } from "@/components/home/CartoonSection";
import { ColoringSection } from "@/components/home/ColoringSection";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 80);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main data-testid="home-page">
      <WelcomeScene />
      <CartoonSection />
      <Gallery />
      <HeroVsVillain />
      <ColoringSection />
    </main>
  );
}
